<template>
  <div>
    <tools-list />
  </div>
</template>

<script>
import toolsList from '@/components/lists/tools/toolsList'

export default {
    components: { toolsList },
}
</script>
